import { StrictMode } from 'react';
import { Toaster } from 'react-hot-toast';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App.tsx';

import { NotificationManager } from './components/NotificationManager';
import ChangeCard from './ChangeCard.tsx';
import PixPayment from './pages/PixPayment.tsx';
import Renewal from './pages/Renewal.tsx';
import CompraAvulsa from './pages/CompraAvulsa.tsx';
import './css/global.css';
import './css/dark-mode-blocker.css';
import TurnstileSkippedBanner from './components/TurnstileSkippedBanner.tsx';
import OpenReplayNaRota from './components/OpenReplayNaRota.tsx';
import { captureFbclid } from './utils/metaClickIds';

// #389: guarda o fbclid do clique antes do router tirar a query da URL
captureFbclid();

// Força o light mode via JavaScript
const forceLightMode = () => {
  // Remove qualquer classe dark do HTML
  document.documentElement.classList.remove('dark');
  document.documentElement.setAttribute('data-theme', 'light');

  // Força o color-scheme para light only
  document.documentElement.style.setProperty('color-scheme', 'light only', 'important');

  // Remove qualquer classe dark do body
  document.body.classList.remove('dark');
  document.body.setAttribute('data-theme', 'light');
  document.body.style.setProperty('color-scheme', 'light only', 'important');
};

// Executa imediatamente
forceLightMode();

// Executa quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', forceLightMode);
} else {
  forceLightMode();
}

// Executa quando a página carregar completamente
window.addEventListener('load', forceLightMode);

// Observa mudanças no DOM para prevenir que elementos sejam alterados para dark mode
const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      const target = mutation.target as HTMLElement;
      if (target.classList.contains('dark')) {
        target.classList.remove('dark');
        target.style.setProperty('color-scheme', 'light only', 'important');
      }
    }
  });
});

// Inicia a observação quando o DOM estiver pronto
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class', 'data-theme'],
    });
  });
} else {
  observer.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['class', 'data-theme'],
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Toaster position="top-right" />
    <NotificationManager />
    <TurnstileSkippedBanner />
    <BrowserRouter>
      {/* Antes do <Routes>: para o OpenReplay nas páginas de link (#665) */}
      <OpenReplayNaRota />
      <Routes>
        <Route path="/alterar-cartao/:token" element={<ChangeCard />} />
        {/* Link curto de troca de cartão (WhatsApp): o código vira token na tela. */}
        <Route path="/cartao/:code" element={<ChangeCard />} />
        <Route path="/pix/:orderId" element={<PixPayment />} />
        {/* Rotas fixas SEMPRE antes de /:plano — o catch-all trataria "renovar"
            como slug de plano e mandaria pro checkout de compra nova. */}
        <Route path="/renovar/:token" element={<Renewal />} />
        {/* Link curto de renovação (WhatsApp): o código vira token na hidratação. */}
        <Route path="/r/:code" element={<Renewal />} />
        {/* Compra avulsa de assinante (sem assinatura nova). */}
        <Route path="/livro-customizado" element={<CompraAvulsa produto="livro-customizado" />} />
        <Route path="/:plano" element={<App />} />
        <Route path="*" element={<App />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
